import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { debounce } from './utilities'

gsap.registerPlugin(SplitText) 

export const splitText = () => {

	console.log('splitTextStarted')

	const split = SplitText.create('[data-split]', {
		type: 'words'
	})

	const splitLines = SplitText.create('[data-split-lines]', {
		type: 'lines',
		linesClass: 'line++',
		mask: 'lines'
	})

	const splitLinesInner = SplitText.create('[data-split-lines-inner] p', {
		type: 'lines',
		linesClass: 'line++',
		mask: 'lines'
	})

	const splitChars = SplitText.create('[data-chars]', {
		type: 'words, chars'
	})

	let windowWidth = window.innerWidth

	const handleResize = () => {
		if (windowWidth != window.innerWidth) {
			console.log('handleResize')
			split.revert()
			splitLines.revert()
			splitChars.revert()
			splitLinesInner.revert()
			windowWidth = window.innerWidth
		}
	}

	const debouncedResize = debounce(handleResize, 300)
	window.addEventListener('resize', debouncedResize)

	console.log('splitTextFinished')
	
}

export default () => {}